// extracted by mini-css-extract-plugin
export default {"layout":"proResourcesLayout_layout__d2Qhz","clientHeaderTitle":"proResourcesLayout_clientHeaderTitle__Nvsd3","colorPrimary":"proResourcesLayout_colorPrimary__B08jw"};